import React, { useEffect, useState } from "react"
import { IoMdClose } from 'react-icons/io'
import searchIcon from "../../../../../assets/icons/search.svg";
import { useIsFetching, useQuery } from "@tanstack/react-query"
import { QueueProps, } from "../../../../../context/FilaContext"
import { ClienteCard } from '../clienteCard'
import { verifyIcon } from "../../../../../utils/verifyIcons"
import { formatCPFCNPJ } from "../../../../../utils/formatCPFCNPJ"
import { apiModulo } from "../../../../../services/api"
import { Loader } from "../../../../generics/loader"
// import { useAuth } from "../../../../../context/AuthContext"

interface FilaFinalizadosProps {
  id_channel?: number
}

export const FilaFinalizados = ({ id_channel }: FilaFinalizadosProps) => {
  const [nome, setNome] = useState('')
  const [listaBuscaNome, setListaBuscaNome] = useState<QueueProps[]>([])


  const { data, isSuccess, isRefetching } = useQuery({
    queryKey: ['finalizados'], queryFn: async () => {
      const { data } = await apiModulo.get('/queues/3', { params: { startDate: '2023-03-01', endDate: '2023-11-20', filtro: id_channel, } })
      return data
    },
    enabled: true,
    refetchInterval: 35000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,

  },)

  const isFetching = useIsFetching()


  useEffect(() => {
    if (isSuccess && data.queue?.length > 0 && listaBuscaNome?.length > 0) {
      const queue = data.queue as QueueProps[]
      setListaBuscaNome(queue.filter(item => item.name.toLocaleLowerCase().includes(nome.toLocaleLowerCase())))
    }
  }, [data?.queue])


  function buscarNome() {
    if (isSuccess && data.queue?.length > 0) {
      const queue = data.queue as QueueProps[]
      setListaBuscaNome(queue.filter(item => item.name.toLocaleLowerCase().includes(nome.toLocaleLowerCase())))
    }
  }

  function clearBusca() {
    setListaBuscaNome([])
    setNome('')
  }

  function mostrarFila(queueData?: QueueProps[]) {
    return (isSuccess && queueData && queueData?.length > 0) && queueData?.map((queue: QueueProps) => (
      <button className=" w-full text-left cursor-pointer" key={queue.id_queue} disabled={isRefetching}>
        <ClienteCard
          nome={queue.name}
          status={3}
          cpf={formatCPFCNPJ(queue.cpf_cnpj)}
          hora_fila={queue.date_origin}
          hora_ini_atendimento={queue.date_end_service}
          icon={verifyIcon(queue.channel.channel === 'E-mail' ? 'email' : queue.channel.channel.toLocaleLowerCase())}
          text={
            "Callback"
          }
        />
      </button>
    ))

  }

  return (
    <div className="flex w-full flex-col items-center overflow-y-hidden">
      <div className="my-2 flex w-full items-center justify-center ">
        <div className="mr-4 h-10 w-full rounded-md bg-gray-50 pr-2 flex items-center ">
          <input
            type="text"
            placeholder="Buscar devedor..."
            className="h-10 w-full bg-transparent px-3 outline-none placeholder:text-gray-400"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
          />
          {
            listaBuscaNome && listaBuscaNome.length > 0 && (
              <button type='button' className="bg-transparent" onClick={clearBusca}>
                <IoMdClose size={24} className="fill-gray-500" />
              </button>
            )
          }
        </div>

        <button type="button" className="flex h-10 w-12 items-center justify-center  rounded-md border-0 bg-primary" onClick={buscarNome}>
          <img src={searchIcon} alt="" className="h-8 w-8" />
        </button>
      </div>

      <div className="mb-2 overflow-y-auto pr-1" >
        <div className="">
          {(isFetching || !isSuccess) && (<div className=" flex justify-center items-center  min-h-[1.5rem]  ">
            {isRefetching && <p className="text-primary text-xs font-bold mr-3">Carregando</p>}
            <Loader />
          </div>)}
          {
            listaBuscaNome && listaBuscaNome.length > 0 ? mostrarFila(listaBuscaNome) : mostrarFila(data?.queue)
          }
        </div>
      </div>
    </div >

  )
}